import Swiper from 'swiper';
import { add_swiper_class } from '@creilsudoise/js/tools/swiper';

export default class Slider {

	constructor()
	{
		Slider.hero();
		Slider.related_posts();
	}

	static hero()
	{
		const slider         = '[data-id="wpiris-hero-slider"]',
			slider_wrapper = '[data-id="wpiris-hero-slider-wrapper"]',
			slider_item    = '[data-id="wpiris-hero-slider-item"]';

		if ( $( slider ).length > 0 ) {

			add_swiper_class( $( slider ), $( slider_wrapper ), $( slider_item ) );

			new Swiper( $( slider ), {
				mousewheel: {
					forceToAxis: true,
				},
				autoplay: {},
				speed: 600,
				slidesPerView: 1,
				loop: true,
				lazy: true,
			} );
		}
	}

	static thematiques_home()
	{
		let slider         = '[data-id="wpiris-thematique-slider"]',
			slider_wrapper = '[data-id="wpiris-thematique-slider-wrapper"]',
			slider_item    = '[data-id="wpiris-entity-slider-item"]';

		if ( $( slider ).length > 0 ) {

			$( slider ).each( function () {
				let self            = $( this );
				let slider_elements = $( this ).find( slider_item );
				let id              = $( this ).attr( 'id' );

				add_swiper_class( $( this ), $( this ).find( slider_wrapper ), $( this ).find( slider_item ) );

				let swiper_thematiques = new Swiper( $( this ), {
					slidesPerView: 1,
					spaceBetween: 10,
					speed: 600,
					touchStartPreventDefault: false,
					simulateTouch: false,
					navigation: {
						nextEl: '[data-arrow-ref="' + id + '"].swiperArrow--next',
						prevEl: '[data-arrow-ref="' + id + '"].swiperArrow--prev',
					},
					breakpoints: {
						370: {
							slidesPerView: 2,
						},
						650: {
							slidesPerView: 'auto',
							spaceBetween: 20
						},
						1000: {
							slidesPerView: 'auto',
							spaceBetween: 30,
						}
					},
				} );
			} );
		}
	}

	static related_posts()
	{
		let slider         = '[data-id="wpiris-entity-slider"]',
			slider_wrapper = '[data-id="wpiris-entity-slider-wrapper"]',
			slider_item    = '[data-id="wpiris-entity-slider-item"]';

		if ( $( slider ).length > 0 ) {

			$( slider ).each( function () {

				let slider_elements = $( this ).find( slider_item );
				let id              = $( this ).attr( 'id' );

				if ( $( slider_elements ).length > 2 || (window.matchMedia( "(max-width: 650px)" ).matches && $( slider_elements ).length > 2) || (window.matchMedia( "(max-width: 1000px)" ).matches && $( slider_elements ).length > 2) ) {

					add_swiper_class( $( this ), $( this ).find( slider_wrapper ), $( this ).find( slider_item ) );

					let swiper_related_post = new Swiper( $( this ), {
						mousewheel: {
							forceToAxis: true,
						},
						keyboard: true,
						spaceBetween: 40,
						speed: 600,
						lazy: true,
						slidesPerView: 4,
						navigation: {
							nextEl: '.swiperArrow--next',
							prevEl: '.swiperArrow--prev',
						},
						breakpoints: {
							320: {
								slidesPerView: 1,
								spaceBetween: 20
							},
							370: {
								slidesPerView: 2,
								spaceBetween: 20
							},
							650: {
								slidesPerView: 2,
								spaceBetween: 40
							},
							1280: {
								slidesPerView: 4,
								spaceBetween: 40
							}
						}
					} );
				}
			} );
		}
	}
}